import { render, staticRenderFns } from "./AuditPendenciesTable.vue?vue&type=template&id=fc55d7c8"
import script from "./AuditPendenciesTable.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports